import { render, staticRenderFns } from "./commodityTable.vue?vue&type=template&id=be017906&scoped=true"
import script from "./commodityTable.vue?vue&type=script&lang=js"
export * from "./commodityTable.vue?vue&type=script&lang=js"
import style0 from "./commodityTable.vue?vue&type=style&index=0&id=be017906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be017906",
  null
  
)

export default component.exports